// @flow
import { creativityMediaModel } from '../../../../../services/creativityMediaModel'

const productImage = require('./dammLemonMug.jpg')
const allTwoEs = require('./animated-1.gif')
const allTwoCa = require('./animated-1-Ca.gif')
const allFourEs = require('./animated-1.gif')
const allFourCa = require('./animated-1-Ca.gif')
const catalogTwoEs = require('./animated-1.gif')
const catalogTwoCa = require('./animated-1-Ca.gif')
const catalogFourEs = require('./animated-1.gif')
const catalogFourCa = require('./animated-1-Ca.gif')

const model = creativityMediaModel({
  catalogID: 'glassware',
  allTwoEs,
  allTwoCa,
  allFourEs,
  allFourCa,
  catalogTwoEs,
  catalogTwoCa,
  catalogFourEs,
  catalogFourCa
})

type Params = {
  catalogID: string,
  numberOfColumns: number,
  language: string
}

export default {
  productImage,
  creativityMedia: (params: Params) =>
    model[params.catalogID][params.numberOfColumns][params.language]
}
